import { render, staticRenderFns } from "./PatientRelevantComorbidities.vue?vue&type=template&id=5949550e&scoped=true&"
import script from "./PatientRelevantComorbidities.vue?vue&type=script&lang=js&"
export * from "./PatientRelevantComorbidities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5949550e",
  null
  
)

export default component.exports